import { createSlice } from "@reduxjs/toolkit";
import { getOrgList } from "../../reduxApi/admin/OrgReduxApi";

const organisationSlice = createSlice({
    name: 'organisation',
    initialState: {
        status: 'idel',
        isFiltered: false,
        organisation: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteOrganisationAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.organisation.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.organisation.splice(index, 1);
                }
            });
        },
        updateOrganisationAction: (state, action) => {
            const index = state.organisation.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.organisation.splice(index, 1, { organisations: action.payload })
            }
        },
        addOrganisationAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.organisation.unshift({ organisations: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOrgList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getOrgList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.organisation = action.payload.data.organisations;
            })
    }
})
export const { deleteOrganisationAction, updateOrganisationAction, addOrganisationAction, setFilteredStatus } = organisationSlice.actions
export default organisationSlice.reducer